import { useState } from "react";
import styled from "styled-components";

import { DomainProvider, providerFaviconUrl } from "../../../../../../model/domainProviders";

const Frame = styled.span<{ $size: number }>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  overflow: hidden;
  color: var(--color-neutral-darkness);
  background: var(--color-neutral-white);
  border-radius: ${props => Math.round(props.$size / 4)}px;

  img {
    width: 62%;
    height: 62%;
    object-fit: contain;
  }

  svg {
    width: 55%;
    height: 55%;
  }
`;

const GlobeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

type Props = {
  provider?: DomainProvider;
  size?: number;
};

/** The provider's favicon on a white tile; a globe for "Outro" or when the favicon fails to load. */
export const ProviderIcon = ({ provider, size = 72 }: Props) => {
  const [failed, setFailed] = useState(false);
  const favicon = providerFaviconUrl(provider);

  return (
    <Frame $size={size} aria-hidden="true">
      {favicon && !failed ? <img src={favicon} alt="" onError={() => setFailed(true)} /> : <GlobeIcon />}
    </Frame>
  );
};
